module.exports = "<p>\n  authservice works!\n</p>\n"